export default function ModalHeader(props) {
  return <div className={`modal-header pb-0 border-0 ${props.className ?? props.class ?? ""}`}>{props.children}</div>;
}
